<template>
    <Panel header="Endereço" :toggleable="true" :collapsed="modo === 'novo'" class="p-mb-4">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>Logradouro</label>
                <InputText v-model="endereco.logradouro" />
            </div>
            <div class="p-field p-col-12 p-md-2">
                <label>Número</label>
                <InputText v-model="endereco.numero" :disabled="!enderecoHabilitado" />
            </div>
            <div class="p-field p-col-12 p-md-4">
                <label>Complemento</label>
                <InputText v-model="endereco.complemento" :disabled="!enderecoHabilitado" />
            </div>
            <div class="p-field p-col-12 p-md-4">
                <label>Bairro</label>
                <InputText v-model="endereco.bairro" :disabled="!enderecoHabilitado" />
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>CEP</label>
                <InputMask v-model="endereco.cep" mask="99999-999" :disabled="!enderecoHabilitado" />
            </div>
            <div class="p-field p-col-12 p-md-2">
                <label>Estado</label>
                <InputText v-model="endereco.estado" :disabled="!enderecoHabilitado" />
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Cidade</label>
                <InputText v-model="endereco.cidade" :disabled="!enderecoHabilitado" />
            </div>
        </div>
        <div v-if="modo === 'edicao'" class="p-d-flex p-jc-end p-mt-3">
            <Button label="Salvar" icon="pi pi-save" @click="salvar" :loading="enviando" />
        </div>
    </Panel>
</template>

<script>
import ClienteIKAcessoService from '@/service/ClienteIKAcessoService';
import { exibirMensagem } from '@/global';

export default {
    props: {
        modo: { type: String, default: 'novo' },
        clienteId: { type: [String, Number], default: null },
        initialData: { type: Object, default: null }
    },
    data() {
        return {
            enviando: false,
            endereco: {
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                cep: null,
                estado: null,
                cidade: null
            }
        };
    },
    computed: {
        enderecoHabilitado() {
            return this.endereco.logradouro && this.endereco.logradouro.length >= 3;
        }
    },
    watch: {
        initialData(newVal) {
            if (newVal) this.endereco = { ...this.endereco, ...newVal };
        }
    },
    methods: {
        validar() {
            return true;
        },
        getData() {
            return { ...this.endereco };
        },
        salvar() {
            this.enviando = true;
            this.clienteService.alterarEndereco(this.clienteId, this.getData())
                .then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Endereço atualizado com sucesso.', life: 3000 });
                })
                .catch(erro => { exibirMensagem(this, erro); })
                .finally(() => { this.enviando = false; });
        }
    },
    created() {
        this.clienteService = new ClienteIKAcessoService();
    },
    mounted() {
        if (this.initialData) this.endereco = { ...this.endereco, ...this.initialData };
    }
};
</script>
